import { useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isEventCallEnabled } from '../../utils/natTraversal';
const SSEListener = ({ onEventReceived }) => {
  const sseRef = useRef(null);
  // const user = useSelector((state) => state.loginReducer.user);

  // Trích xuất các giá trị cần thiết ra ngoài
  const agent = useSelector((state) => state.loginReducer.user?.agents?.[0]);
  const endpoint_id = agent?.endpoint_id;
  const nat_traversal = agent?.nat_traversal;

  const connectSSE = useCallback(() => {
    if (!endpoint_id) {
        console.log("[callEvent]: No endpoint_id available");
        return;
    }
    
    try {
      
      if (!isEventCallEnabled(nat_traversal)) {
        return;
      }
    } catch (error) {
      console.log("[SSEListener]: error=", error.message);
    }
    // Close existing connection if any
    if (sseRef.current) {
      sseRef.current.close();
    }

    
    console.log("[callEvent]: Connecting to event Server for ", endpoint_id);
    const eventSource = new EventSource(`${process.env.REACT_APP_DOMAIN}/callEvent/eventRegisterCC1/${endpoint_id}`);

    eventSource.onopen = () => {
      console.log("[callEvent]: Connection established");
    };

    eventSource.onmessage = (event) => {
      console.log("[callEvent]: Received message", event.data);
      try {
        if (event.data !== "Registered") {
          const eventData = JSON.parse(event.data);
          // Pass the event data to the parent component
          onEventReceived(eventData);
        }

      } catch (error) {
        console.error("[callEvent]: Error parsing event data", error);
        console.log("[callEvent-catch errow with data]: event.data", event.data);
      }
    };

    eventSource.onerror = (error) => {
      console.error("[callEvent]: Connection error", error);
      // Try to reconnect after a delay
      setTimeout(() => {
        if (eventSource.readyState === EventSource.CLOSED) {
          connectSSE();
        }
      }, 5000);
    };

    sseRef.current = eventSource;
  }, [endpoint_id,nat_traversal, onEventReceived]);

  useEffect(() => {
    if (endpoint_id) {
      connectSSE();
    }

    // Clean up on unmount
    return () => {
      if (sseRef.current) {
        console.log("[callEvent]: Closing connection on unmount");
        sseRef.current.close();
        sseRef.current = null;
      }
    };
  }, [endpoint_id, connectSSE]);

  // This component doesn't render anything
  return null;
};

export default SSEListener;
